<template>

  <div id="wrapper">

    <TemplateSide />

    <div id="page-wrapper" class="gray-bg">

      <div class="row border-bottom">
        <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">

          <div class="navbar-header">
            <a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="#"><i class="fa fa-bars"></i> </a>
            <!--
            <form role="search" class="navbar-form-custom" action="search_results.html">
              <div class="form-group">
                <input type="text" placeholder="Search for something..." class="form-control" name="top-search" id="top-search">
              </div>
            </form>
            -->
          </div>

          <TemplateProfile />

        </nav>
      </div>

      <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
          <h2></h2>
          <slot name="breadcrumb"/>
        </div>

        <div class="col-lg-2">
        </div>
      </div>
      
      <slot name="test"/>
      
      <div class="wrapper wrapper-content animated">

        <slot />

      </div>

      <div class="footer">
        <div class="float-right">
          <span class="action-buttons">
            <a href="https://www.facebook.com/ParkAideMobile/" target="_blank">
              <i class="ace-icon fa fa-facebook-square text-primary bigger-150"></i>
            </a>
          </span>
        </div>
        <div>
          <strong>Copyright</strong> PARKAIDE &copy; 2018
        </div>
      </div>

    </div>
    
  </div>
  
</template>

<script>
import TemplateSide from "@/components/Template/TemplateSide";
import TemplateProfile from "@/components/Template/TemplateProfile";

export default {
  name: "TemplateMain",
  components: {
    TemplateSide,
    TemplateProfile,
  },
  data() {
    return {
    };
  },
  created() {
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateMain.vue